module.exports = __webpack_public_path__ + "img/tx-history-spinner.6078e266.svg";